import { useEffect, useState } from 'react';
import { useShipping } from '@/contexts/shippingContext';
import { useUser } from '@/contexts/userContext';
import { getDiffShippingAddressId } from '@/utils/getDiffShippingAddressId';
import { useAddressFields } from './useAddressFields';

export const useStoredDeliveryAddresses = () => {
  const {
    initialAddress,
    setDeliveryAddress,
    setStoredAddressIds,
    storedAddressIds,
  } = useShipping();
  const { deliveryAddresses } = useUser();
  const deliveryAddressIds = deliveryAddresses.map(({ id }) => id ?? '');
  const lengthDeliveryAddressIds = deliveryAddressIds.length;

  const { getAddressField } = useAddressFields();

  const storedAddressFields = deliveryAddresses?.map(address =>
    getAddressField({
      address,
    }),
  );

  const newAddressField = getAddressField({
    address: initialAddress,
    isNew: true,
  }).cta;

  const lengthStoredIds = storedAddressIds.length;

  const useDiffedId =
    lengthStoredIds > 0 && lengthStoredIds !== lengthDeliveryAddressIds;

  const initialAddressId = deliveryAddressIds[0];

  const diffedId = getDiffShippingAddressId({
    deliveryAddresses,
    storedAddressIds,
  });

  const [selectedAddressId, setSelectedAddressId] = useState(initialAddressId);

  useEffect(() => {
    const addressId = useDiffedId ? diffedId : selectedAddressId;

    if (useDiffedId && diffedId) {
      setStoredAddressIds(currentIds => [...currentIds, diffedId]);
    }

    if (addressId) {
      setSelectedAddressId(addressId);
    }
  }, [diffedId, selectedAddressId, setStoredAddressIds, useDiffedId]);

  useEffect(() => {
    const selectedAddress = deliveryAddresses.find(
      address => address.id === selectedAddressId,
    );

    if (selectedAddress) {
      setDeliveryAddress(selectedAddress);
    }
  }, [deliveryAddresses, selectedAddressId, setDeliveryAddress]);

  return {
    fields: storedAddressFields,
    handleSelectionChange: setSelectedAddressId,
    newAddressField,
    selectedAddressId,
  };
};
